import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class EnterCertifitionListService {

  constructor(private http: HttpCommonService) {
  }


  findEntryCompanys(pageNo, pageSize): any {
    return this.http.post("/user/center/xhsRest/entry/findEntryCompanys", {pageNo, pageSize});
  }

  /**
   * 是否处于入驻流程
   * @param companyId
   * @returns {Observable<any>}
   */
  isUnderEntry(companyId): Observable<any> {
    return this.http.get("/user/center/xhsRest/entry/isUnderEntry", {companyId: companyId});
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/enter-certification-list.service.ts